// API Configuration
// Automatically uses environment variables from .env.development or .env.production
// Defaults to production URLs for safety (if env vars are missing, production still works)

const config = {
  dictAPI: process.env.REACT_APP_DICT_API || 'https://vocabularyx.com',
  bookAPI: process.env.REACT_APP_BOOK_API || 'https://vocabularyx.com/book',
};

export default config;
